import { Select, Table } from "antd";
import React from "react";
import s from "./MobileDeclarantTable.module.scss";
import moment from "moment";
import { getStatusTag } from "../../utils/functions";
import { Option } from "antd/es/mentions";
import { useTranslation } from "react-i18next";
import { EditTableType } from "../../pages/EditUserApplication/EditUserApplication";

interface Props {
  dataSource: EditTableType[];
  setIsRefuse?: (isRefuse: boolean) => void;
}

const MobileDeclarantTable: React.FC<Props> = ({ dataSource, setIsRefuse }) => {
  const { t } = useTranslation();
  const column = [
    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 200,
      render: (text: string) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Информация"),
      dataIndex: `info`,
      width: 600,
      render: (text: string) => <div className={s.font}>{text}</div>,
    },
  ];

  return (
    <div>
      <Table
        pagination={false}
        columns={column}
        dataSource={dataSource.map((it) => ({
          application_number: it.application_number,
          info: (
            <div>
              <div className={s.table_item}>
                <div className={s.table_title}>{t("Статус")}: </div>
                <div className={s.table_value}>
                  {it.status && getStatusTag(it.status, "sm", t)}
                </div>
              </div>
              {
                <div className={s.table_item}>
                  <div className={s.table_title}>{t("Пользователь")}: </div>
                  <div className={s.table_value}>{it.user}</div>
                </div>
              }
              <div className={s.table_item}>
                <div className={s.table_title}>{t("Дата регистрации")}: </div>
                <div className={s.table_value}>
                  {moment(it?.created_at).format("DD.MM.YYYY")}
                </div>
              </div>

              {Number(it?.price) > 0 && (
                <div className={s.table_item}>
                  <div className={s.table_title}>{t("Сумма к оплате")}: </div>
                  <div className={s.table_value}>{it?.price}</div>
                </div>
              )}
              <div className={s.table_item}>
                <div className={s.table_title}>
                  {t("Дата изменения статуса")}:{" "}
                </div>
                <div className={s.table_value}>{it?.status_change_dates}</div>
              </div>
              {it.comments && (
                <div className={s.table_item}>
                  <div className={s.table_title}>{t("Комментарий")}: </div>
                  <div className={s.table_value}>{it?.comments}</div>
                </div>
              )}
              {it.comments && (
                <div className={s.table_item}>
                  <div className={s.table_title}>{t("Действия")}: </div>
                  <div className={s.table_value}>
                    <Select
                      className={"m_select"}
                      defaultValue={t("Просмотр")}
                      onSelect={(value: string | null | undefined) =>
                        value === "refuse"
                          ? setIsRefuse && setIsRefuse(true)
                          : setIsRefuse && setIsRefuse(false)
                      }
                    >
                      <Option value="edit" key="1" style={{ fontSize: "12px" }}>
                        {t("Просмотр")}
                      </Option>
                      <Option
                        value="refuse"
                        key="2"
                        style={{ fontSize: "12px" }}
                      >
                        {t("Редактирование")}
                      </Option>
                    </Select>
                  </div>
                </div>
              )}
            </div>
          ),
        }))}
      />
    </div>
  );
};

export default MobileDeclarantTable;
